import React, { useState, useMemo } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import { Badge, Button, Card, CardBody } from "reactstrap"

import EcommerceOrdersModal from "../Ecommerce/EcommerceOrders/EcommerceOrdersModal"
import { latestTransaction } from "../../common/data/dashboard"
import viewIcon from "../../assets/images/view-icon.png"
import downloadIcon from "../../assets/images/download-icon.png"
import TableContainer from "../../components/Common/TableContainer"
import { Link, useNavigate } from "react-router-dom"
import { notification } from "shared/utility/Utility"
import API_SERVICE from "shared/services/api-services"

const LatestTranaction = ({ data, isLoading, setLoading }) => {
  const [modal1, setModal1] = useState(false)
  const navigate = useNavigate()
  const toggleViewModal = () => setModal1(!modal1)
  function downloadFile(data, name, fileType = "text/CSV") {
    const blob = new Blob([data], { type: fileType })
    const url = window.URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.setAttribute("href", url)
    a.setAttribute("download", name)
    a.click()
  }
  const columns = useMemo(
    () => [
      {
        header: "Registration ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          return (
            <Link to="#" className="text-body fw-bold">
              #INVG{cellProps.row.original.id}
            </Link>
          )
        },
      },
      {
        header: "Company Name",
        accessorKey: "companyName",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: cellProps => {
          const { firstName, LastName } = cellProps.row.original
          const fullName = [firstName, LastName].filter(Boolean).join(" ")

          return fullName ? <span>{fullName}</span> : null
        },
      },
      {
        header: "Company Number",
        accessorKey: "companyNumber",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Country",
        accessorKey: "country",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Actions",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cell => {
          return (
            <div style={{ display: "flex", gap: "8px" }}>
              <img
                src={viewIcon}
                onClick={() =>
                  navigate(`/registration-list/${cell.row.original.id}`)
                }
              />
              <img
                src={downloadIcon}
                onClick={async () => {
                  try {
                    setLoading(true)
                    await API_SERVICE.exportRegistration(
                      cell?.row?.original?.id
                    ).then(res => {
                      downloadFile(
                        res,
                        `${cell.row?.original?.companyName}-Registration Details.pdf`,
                        "application/pdf"
                      )
                    })
                  } catch (e) {
                    notification("error", e)
                  } finally {
                    setLoading(false)
                  }
                }}
              />
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />

      <Card>
        <CardBody>
          <div className="mb-4 h4 card-title">Latest Registration</div>

          <TableContainer
            columns={columns}
            data={data || []}
            isGlobalFilter={false}
            tableClass="align-middle table-nowrap mb-0"
            theadClass="table-light"
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

LatestTranaction.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
}

export default withRouter(LatestTranaction)
